import React, { useState, useEffect, useMemo, useContext } from 'react';
import ModuleTitle from '../../../module-title';
import { INDEX_GROUP, DEFAULT_INDEX, INDEX_GROUP_MAP } from './config';
import { Checkbox, Button, Empty, Radio } from 'antd';
import { Chart, Interval, Line, Axis, Point, Tooltip, Legend } from 'bizcharts';
import './index.less';
import apis from '../../../../apis';
import { message } from 'antd';
import ProviderUserTypeInfo from '../../../../provider-userType-info';
import { formatPrice } from '@/common/utils';
import ScrollX from '@/components/scroll-x';

const TrendAnalysis = (props) => {
  const value = useContext(ProviderUserTypeInfo);
  const [selectTag, setSelectTag] = useState(DEFAULT_INDEX);
  const [list, setList] = useState([]);
  const [conditions, setConditions] = useState({});
  const [position, setPosition] = useState('0');

  const changeCheckedIndex = (val) => {
    setSelectTag(val);
  };
  useEffect(() => {
    setConditions((conditions) =>
      Object.assign(
        {},
        conditions,
        { realTimeData: props.realTimeData },
        { planCode: props.planCode },
        { platform: props.platform },
        { ...value },
        { isAccumulate: '0' }
      )
    );
  }, [props.realTimeData, props.planCode, props.platform, value]);
  const dataSource = useMemo(() => getData(list, selectTag), [list, selectTag]);
  useEffect(() => {
    if (!conditions.planCode) return;
    apis.getActivityTrendDetailData({ ...conditions, isAccumulate: position }).then((res) => {
      const {
        ret,
        data: { values = [] },
      } = res;
      if (ret === '0') {
        setList(values);
      }
    });
  }, [conditions, position]);
  let max = 0;
  let rateMax = 0;
  if (dataSource && dataSource.length > 0) {
    dataSource.forEach((item) => {
      max = item.value && item.value > max ? item.value : max;
    });
    dataSource.forEach((item) => {
      rateMax = item.rateValue && item.rateValue > rateMax ? item.rateValue : rateMax;
    });
  }

  const scale = {
    time: {
      type: 'cat',
    },
    value: {
      min: 0,
      max: Math.ceil(max / 5) * 5,
      tickInterval: Math.ceil(max / 5),
      formatter: (val) => {
        return formatPrice(val);
      },
    },
    rateValue: {
      min: 0,
      max: rateMax,
      tickInterval: rateMax / 5,
      formatter: (val) => {
        return formatPrice(val * 100) + '%';
      },
    },
  };

  const downLoad = async (params) => {
    try {
      const res = await apis.getActivityTrendDetailData({ ...conditions, downLoad: true, isAccumulate: position });
      const { ret, msg, data } = res;
      if (ret != 0) throw msg || '导出数据失败';
      message.success('已开始导出数据，导出成功后将发到您的咚咚和邮箱，请注意查收！');
    } catch (ex) {
      message.error(ex);
    }
  };

  const chart = useMemo(() => {
    return (
      dataSource && (
        <ScrollX limit={20} width={550} height={420} length={dataSource.length}>
          <Chart height={400} autoFit data={dataSource} padding="auto" scale={scale}>
            <Interval
              position="time*value"
              color="name"
              adjust={[
                {
                  type: 'dodge',
                  marginRatio: 0.1,
                },
              ]}
            />
            <Axis name="rateValue" position="right" />
            <Axis
              name="time"
              label={{
                autoHide: false,
              }}
            />
            <Axis name="value" position="left" />
            <Line shape="smooth" position="time*rateValue" color="name" />
            <Point shape="circle" position="time*rateValue" color="name" />
            <Legend position="bottom-left" />
            <Tooltip shared />
          </Chart>
        </ScrollX>
      )
    );
  }, [dataSource]);

  return (
    <div className="trend-analysis-bg">
      <ModuleTitle title="趋势分析">
        <div className="trend-analysis-container">
          <span className="index-group-title">数据指标：</span>
          <Checkbox.Group options={INDEX_GROUP} defaultValue={DEFAULT_INDEX} onChange={changeCheckedIndex} />
        </div>
        {dataSource ? (
          <>
            <div style={{ display: 'flex', marginBottom: '10px', justifyContent: 'flex-end' }}>
              {props.realTimeData && (
                <Radio.Group
                  onChange={(ev) => {
                    setPosition(ev.target.value);
                    // setConditions({ ...conditions, isAccumulate: ev.target.value });
                  }}
                  value={position}
                  style={{ marginRight: '10px' }}
                  buttonStyle="solid"
                >
                  <Radio.Button value="0">分时</Radio.Button>
                  <Radio.Button value="1">累计</Radio.Button>
                </Radio.Group>
              )}

              <Button
                type="primary"
                onClick={() => {
                  downLoad();
                }}
              >
                导出数据
              </Button>
            </div>
            {chart}
          </>
        ) : (
          <Empty />
        )}
      </ModuleTitle>
    </div>
  );
};

function getData(list, selectTag) {
  if (!list.length || !selectTag.length) return;
  const res = [];
  selectTag.map((item) => {
    list.map((dataItem) => {
      // return {
      //   time: dataItem.dt,
      //   value: dataItem[item],
      //   name: INDEX_GROUP_MAP[item],
      // };
      if (item === 'uvClickRate' || item === 'uvDealRate') {
        res.push({
          time: dataItem.dt,
          rateValue: dataItem[item],
          name: INDEX_GROUP_MAP[item],
        });
      } else {
        res.push({
          time: dataItem.dt,
          value: dataItem[item],
          name: INDEX_GROUP_MAP[item],
        });
      }
    });
    // res.push(data);
  });
  return res;
}
export default TrendAnalysis;
